import {match} from 'ts-pattern';

import type {BusinessCaseResponseBody} from '@dms/api/sales';

import type {BusinessCaseType} from '@prompt-bridge/shared/ai-assistant-core';

export const toBusinessCaseType = (
  type: BusinessCaseResponseBody['businessCaseType']
): BusinessCaseType | null =>
  match(type)
    .returnType<BusinessCaseType | null>()
    .with('SELLING', () => 'SELLING')
    .with('BUYING', 'PURCHASE_BROKERAGE', () => 'BUYING')
    .with('SWAP', null, () => null)
    .exhaustive();
